import type { TextProps, TextStyle } from "react-native";
import type { AnimatedProps } from "react-native-reanimated";
import type { Sx } from "@gluestack-style/react/lib/typescript/types";
import type { Property } from "csstype";

export const textType = {
	"heading-h1": "heading-h1",
	"heading-h2": "heading-h2",
	"heading-h3": "heading-h3",
	"heading-h4": "heading-h4",
	"heading-h5": "heading-h5",
	"heading-h6": "heading-h6",
	paragraph: "paragraph",
	"paragraph-small": "paragraph-small",
} as const;

export const textWeight = {
	normal: "normal",
	bold: "bold",
	semibold: "semibold",
} as const;

interface TypographyBaseProps extends TextProps {
	children: React.ReactNode;
	type?: keyof typeof textType;
	// color?: keyof typeof textColor;
	color?: any;
	weight?: keyof typeof textWeight;
	fontWeight?: TextStyle["fontWeight"];
	sx?: any;
	uppercase?: boolean;
	underline?: boolean;
}

type TypographyAnimatedProps = TypographyBaseProps & {
	animatedProps: AnimatedProps<TextProps>;
	isAnimated: true;
};

type TypographyStaticProps = TypographyBaseProps & {
	animatedProps?: never;
	isAnimated?: false;
};

export type TypographyProps = TypographyAnimatedProps | TypographyStaticProps;
